import { render } from "./DoubleColumnsTextBlock.vue?vue&type=template&id=54353a95&scoped=true&ts=true"
import script from "./DoubleColumnsTextBlock.vue?vue&type=script&lang=ts"
export * from "./DoubleColumnsTextBlock.vue?vue&type=script&lang=ts"

import "./DoubleColumnsTextBlock.vue?vue&type=style&index=0&id=54353a95&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.29_vue@3.5.27_typescript@5.9.3__webpack@5.105.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54353a95"]])

export default __exports__